import { LoginEmail } from "@ai-platform/contracts";
import type { ReadableStorage, WritableStorage } from "./storage.ts";

/*
 * The e-mail address the browser remembers for the next login (UC-02 step 1, ADR-078). Browser
 * state, not server data (ADR-076 point 2): stored when the first step of the login form is
 * sent, after the contract accepted it, and kept on logout (TL, 2026-10-08). Only an address
 * the contract accepts is read back, so a value edited by hand in the storage never reaches the
 * form.
 */

/** localStorage key of the remembered address. */
export const LOGIN_EMAIL_STORAGE_KEY = "loginEmail";

/** The remembered address, normalised by the contract; missing, broken or blocked storage is `""`. */
export function readLoginEmail(storage: ReadableStorage | null): string {
  try {
    const parsed = LoginEmail.safeParse(storage?.getItem(LOGIN_EMAIL_STORAGE_KEY));
    return parsed.success ? parsed.data : "";
  } catch {
    return "";
  }
}

/** Remembers an address the contract accepted (the output of `LoginEmail`); a blocked storage is ignored. */
export function writeLoginEmail(storage: Pick<WritableStorage, "setItem"> | null, email: string): void {
  try {
    storage?.setItem(LOGIN_EMAIL_STORAGE_KEY, email);
  } catch {
    // Storage unavailable: the form starts empty next time.
  }
}
